import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {CrownFilled} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";

export abstract class AChallenge extends ABusiness {
    readonly icon = () => h(CrownFilled, {style: 'color:#1677ff'});
    readonly title = '挑战';
    readonly description = '用小成本奖品作为杠杆，撬动朋友圈的裂变式传播。';
    readonly implementations = [{value: 'praise', label: '集赞式'}, {value: 'task', label: '任务式'}];

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }
}
